import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
export default function isSearchMatch(itemName, searchValue) {
  var matches = itemName.toLowerCase().includes(searchValue.toLowerCase());
  return matches;
}